export default __webpack_public_path__ + "static/media/splash-hero-right.070ea8aa.svg";